import { Autocomplete, AutocompleteItem, Button, Input } from "@nextui-org/react";
import { useEffect, useState } from "react";
import { apiRoute, ENUM_ADVSEARCH_PARAM, ENUM_INPUT_TYPE, ENUM_STATUS } from "../constants/enum";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { isMobile } from "react-device-detect";
import { useFetchWithBody, usePost } from "../api/reactQueryCustomHooks";
import { useSelector } from "react-redux";
import { compose } from "@reduxjs/toolkit";

// components/AdvancedFilter.js
export default function AdvancedFilter({ visibleFilterField, apiParam, selFilter, onApply }) {
    const { compCode } = useSelector((state) => state.company)
    const [filterParam, setFilterParam] = useState({})
    const [lwRatioData, setLwRatioData] = useState([])
    // const formField = {
    //   VouNo: "VouNo",
    //   Shape: "Shape",
    //   Color: "Color",
    //   Purity: "Purity",
    //   Size: "Size",
    //   LwRatio: "LwRatio",
    //   Party: "Party",

    // }

    const FILTER_STATUS = [
        { value: "Paid", key: [ENUM_STATUS.Paid] },
        { value: "Pending", key: [ENUM_STATUS.Pending] },
        { value: "Part Paid", key: [ENUM_STATUS.PartPaid] }
    ]


    const { isPending: isLoadingData, data: itemsMasterData = [], mutate: filterItemsData } = usePost({
        url: apiRoute.transaction.SaleEntry.entryMasterData,
        queryKey: "fetchSearchEntryMasterData",

    })
    const inputBoxes = {
        Row1: [
           
            
            {

                id: ENUM_ADVSEARCH_PARAM.Status,
                name: ENUM_ADVSEARCH_PARAM.Status,
                placeholder: "Status",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: FILTER_STATUS,
                itemkey: "key",
                itemvalue: "value",
                isrequired: false,
            },
             {

                id: ENUM_ADVSEARCH_PARAM.Item,
                name: ENUM_ADVSEARCH_PARAM.Item,
                placeholder: "Item",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: itemsMasterData && itemsMasterData?.itemMaster ? itemsMasterData?.itemMaster : [],
                itemkey: "Item_Code",
                itemvalue: "Item_Desc",
                isrequired: false,
            },
        ],
        Row2: [
            {
                id: ENUM_ADVSEARCH_PARAM.VouFromDate,
                name: ENUM_ADVSEARCH_PARAM.VouFromDate,
                placeholder: "From Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: ENUM_ADVSEARCH_PARAM.VouToDate,
                name: ENUM_ADVSEARCH_PARAM.VouToDate,
                placeholder: "To Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: false,
            }
        ],

        Row3: [
            {
                id: ENUM_ADVSEARCH_PARAM.DueFromDate,
                name: ENUM_ADVSEARCH_PARAM.DueFromDate,
                placeholder: "Due From Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: ENUM_ADVSEARCH_PARAM.DueToDate,
                name: ENUM_ADVSEARCH_PARAM.DueToDate,
                placeholder: "Due To Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: false,
            }
        ],
        Row4: [
            {
                id: ENUM_ADVSEARCH_PARAM.VouNo,
                name: ENUM_ADVSEARCH_PARAM.VouNo,
                placeholder: "Memo No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false

            },

        ],



        Row5: [{
            id: ENUM_ADVSEARCH_PARAM.Party,
            name: ENUM_ADVSEARCH_PARAM.Party,
            placeholder: "Party",
            type: ENUM_INPUT_TYPE.autocomplete,
            size: "sm",
            label: "",
            data: itemsMasterData && itemsMasterData?.acMaster ? itemsMasterData?.acMaster : [],
            itemkey: "Party_Id",
            itemvalue: "Party_Name",
            isrequired: false,
        },
        {

            id: ENUM_ADVSEARCH_PARAM.Broker,
            name: ENUM_ADVSEARCH_PARAM.Broker,
            placeholder: "Broker",
            type: ENUM_INPUT_TYPE.autocomplete,
            size: "sm",
            label: "",
            data: itemsMasterData && itemsMasterData?.brokerMaster ? itemsMasterData?.brokerMaster : [],
            itemkey: "Party_Id",
            itemvalue: "Party_Name",
            isrequired: false,
        },

        ],



    }
    useEffect(() => {
        if (apiParam && Object.keys(apiParam).length > 0) {
            filterItemsData({
                data: {
                    compcode: apiParam.CompCode,
                    trade_of: apiParam.TradeOf,
                    bill_type:apiParam.BillType,
                }
            })
        }
    }, [apiParam])
    //console.log(itemsMasterData, "ft", apiParam,visibleFilterField)
    useEffect(() => {
        if (selFilter && Object.keys(selFilter).length > 0) {
            setFilterParam(selFilter)
        }
    }, [selFilter])

    const handleApply = () => {
        const cleanedFilters = Object.fromEntries(
            Object.entries(filterParam).filter(
                ([_, value]) => value !== "" && value !== null && value !== undefined
            )

        );
        onApply(cleanedFilters); // send values to parent
    };
    const handleClose = (() => {
        //onClose(true)
    })
    const handleClear = () => {
        onApply({})
    }
    const handleChange = (e) => {
        const { value, name } = e.target
        setFilterParam({ ...filterParam, [name]: value })
    }
    const handleAutoCompleteChange = (value, name) => {

        setFilterParam({ ...filterParam, [name]: value })
    }
    const handleDateChange = (value, name) => {
        if (value != "Invalid Date")
            setFilterParam({ ...filterParam, [name]: value })
    }
    return (
        <div>
            {/* <h3>Advanced Filter</h3> */}
            <div className="max-h-80 overflow-scroll">
                {
                    Object.keys(inputBoxes).map((key, ind) => (
                        <div key={key + ind}>
                            <div className={`  flex gap-4 align-top items-baseline mb-2 `}>
                                {
                                    inputBoxes[key].map((item, indx) =>
                                        visibleFilterField.includes(item.name) ?
                                            item.type == ENUM_INPUT_TYPE.select ? (
                                                <></>
                                            ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                <>
                                                    <Autocomplete
                                                        size="sm"
                                                        name={item.name}
                                                        label={item?.placeholder}
                                                        eventResizeFeature={true}
                                                        selectionMode="single"
                                                        showScrollIndicators={true}
                                                        labelPlacement={"outside"}
                                                        placeholder={item.placeholder}
                                                        isRequired={item.isrequired}
                                                        isLoading={isLoadingData}
                                                        menuTrigger="input"
                                                        className="max-w-23 font-semibold text-xs"
                                                        classNames={{
                                                            label: "text-xs text-black ",
                                                        }}
                                                        isClearable={false}
                                                        isVirtualized
                                                        defaultItems={
                                                            item.data ? item.data : []
                                                        }
                                                        onSelectionChange={(e) =>
                                                            handleAutoCompleteChange(e, item.name)
                                                        }
                                                        //color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                                        //onChange={handleFormSelectionChange}
                                                        selectedKey={filterParam[item.name]}
                                                    >
                                                        {(list) => (
                                                            <AutocompleteItem

                                                                key={list[item.itemkey]}
                                                            >
                                                                {list[item.itemvalue]}
                                                            </AutocompleteItem>
                                                        )}
                                                    </Autocomplete>
                                                </>
                                            ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                <div className=" w-full flex items-center">
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            label={item.placeholder}
                                                            views={["day", "month", "year"]}
                                                            format="DD/MM/YYYY"
                                                            value={
                                                                filterParam[item.name]
                                                                    ? dayjs(filterParam[item.name])
                                                                    : filterParam[item.name]
                                                            }
                                                            onChange={(newValue) => {
                                                                setFilterParam((prev) => {
                                                                  return {
                                                                    ...prev,
                                                                    [item.name]: newValue != '' && newValue != 'Invalid Date' ?
                                                                      dayjs(newValue).format("YYYY-MM-DD") : null,
                                                                  };
                                                                });
                                                              }}
                                                            //isRequired={item.required}
                                                            className="w-full"
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small",
                                                                    sx: {
                                                                        fontSize: "0.75rem",          // smaller font
                                                                        "& .MuiInputBase-root": {
                                                                            padding: "4px 8px",         // reduce height
                                                                            fontSize: "0.75rem",

                                                                        },
                                                                        "& input": {
                                                                            padding: "4px 0",           // tweak input spacing
                                                                        },
                                                                        "& label": {
                                                                            fontSize: "0.75rem",
                                                                            fontWeight: "300",
                                                                            color: "black"       // smaller label
                                                                        },
                                                                    }
                                                                },
                                                                popper: {
                                                                    modifiers: [
                                                                        {
                                                                            name: 'offset',
                                                                            options: {
                                                                                offset: [0, 8],
                                                                            },
                                                                        },
                                                                    ],
                                                                    disablePortal: true, // ⬅️ This renders popup inside parent
                                                                },
                                                            }
                                                            }
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            ) : (

                                                <Input
                                                    type={item.type}
                                                    name={item.name}
                                                    id={item.name}
                                                    placeholder={item.placeholder}
                                                    label={item.placeholder}
                                                    labelPlacement="outside"
                                                    isRequired={item.isrequired}
                                                    value={filterParam[item.name]}
                                                    variant="bordered"
                                                    onChange={(e) => handleChange(e)}
                                                    size={"sm"}
                                                    classNames={{
                                                        //inputWrapper:"bg-red-700 h-1 px-2 m-0",
                                                        label: "text-xs text-black font-bold",
                                                    }}
                                                ></Input>
                                            )
                                            : ""
                                    )
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
            {/* Your filter fields here */}
            <div className="m-2 text-center flex gap-4  items-center">
                <Button size="sm" color="danger" className="font-semibold h-6 bg-sky-700" onPress={handleApply}>Apply</Button>
                <Button size="sm" color="warning" className="font-semibold h-6 " onPress={handleClear}>Clear</Button>
            </div>

        </div>
    );
}
